/**
 * Lookup model
 */
export class LookupModel {
  /**
   * ID
   */
  id: number;

  /**
   * Name
   */
  name: string;
}
